import { PlayList } from "../../../../Components/Sounds/PlayList";
import { GameApp } from "../../../../GameApp";
import { GameManager } from "../../../../Managers/GameManager";
import { Communication, Platforms } from "neo-games";
import { BaseModel } from "../../../../GameComponents/Base/BaseModel";
import { IErrorResponse } from "neo-common/Engine/ApiClient/Types";
import { Languages } from "../../../../Utils/Languages";
import { StringUtils, Utils } from "neo-common";

export class SessionTimer {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected static dialog: HTMLElement;

    protected static title: HTMLElement;

    protected static text: HTMLElement;

    protected static buttonsHolder: HTMLElement;

    protected static buttons: Array<HTMLElement>;

    protected static callback: (response: any) => void;

    protected static response: any;

    protected static step: number;

    protected static intervals: Array<number>;

    protected static intervalIndex: number;

    protected static intervalHolder: HTMLElement;

    protected static intervalDisplay: HTMLElement;

    //******************************************************************************************************************
    //  POSTPONE
    //******************************************************************************************************************

    public static postpone(callback: (response: any) => void, response: any): void {
        if (
            !Utils.isNullOrUndefined(response) &&
            !Utils.isNullOrUndefined(response.messages) &&
            response.messages.length > 0
        ) {
            if (Utils.isNullOrUndefined(SessionTimer.dialog)) {
                SessionTimer.dialog = document.getElementById("messageDialog");

                if (!Utils.isNullOrUndefined(SessionTimer.dialog)) {
                    SessionTimer.dialog.classList.add("sessionTimer");
                    SessionTimer.title = SessionTimer.dialog.getElementsByTagName("h3")[0];
                    SessionTimer.text = document.getElementById("messageDialogText");

                    SessionTimer.buttonsHolder = document.getElementById("messageDialogButtons");
                    SessionTimer.buttons = [];
                }
            }

            if (Utils.isNullOrUndefined(SessionTimer.dialog)) {
                callback(response);
            } else {
                SessionTimer.callback = callback;
                SessionTimer.response = response;
                SessionTimer.step = 0;
                SessionTimer.handle();
            }
        } else {
            callback(response);
        }
    }

    //******************************************************************************************************************
    //  UPDATE DIALOG DATA
    //******************************************************************************************************************

    protected static updateDialogData(data: any): void {
        SessionTimer.resetDialogData();

        if (!Utils.isNullOrUndefined(data["title"])) {
            SessionTimer.title.innerHTML = data["title"];
        }

        if (!Utils.isNullOrUndefined(data["text"])) {
            SessionTimer.text.innerHTML = data["text"];
        }

        if (!Utils.isNullOrUndefined(data["actions"])) {
            SessionTimer.removeAllButtons();

            for (let i = 0; i < data["actions"].length; i++) {
                let action = data["actions"][i];

                switch (action.type) {
                    case "continue":
                        SessionTimer.createButton(action["text"], SessionTimer.actionContinue.bind(this, action));
                        break;
                    case "exit":
                        SessionTimer.createButton(action["text"], SessionTimer.actionExit.bind(this, action));
                        break;
                }
            }
        }

        if (!Utils.isNullOrUndefined(data["intervals"])) {
            SessionTimer.createIntervals(data["intervals"]);
        }
    }

    protected static resetDialogData(): void {
        //default title
        SessionTimer.title.innerHTML = Languages.getRid("DLG_INFO");

        //remove all custom buttons
        SessionTimer.removeAllButtons();

        //create default continue button
        SessionTimer.createButton(Languages.getRid("CONTINUE"), SessionTimer.actionContinue);

        if (SessionTimer.intervalHolder != null) {
            SessionTimer.intervalHolder.parentElement.removeChild(SessionTimer.intervalHolder);
            SessionTimer.intervalHolder = null;
        }
    }

    protected static removeAllButtons(): void {
        while (SessionTimer.buttons.length > 0) {
            let button = SessionTimer.buttons.pop();
            SessionTimer.buttonsHolder.removeChild(button);
        }
    }

    protected static disableAllButtons(): void {
        for (let i = 0; i < SessionTimer.buttons.length; i++) {
            let button = SessionTimer.buttons[i];

            if (button != null) {
                button.classList.add("_disabled");
                button.onclick = null;
            }
        }
    }

    protected static createButton(text: string, action: (data: any) => void): void {
        let button: HTMLElement = document.createElement("div");
        button.textContent = text;
        button.classList.add("dialogBtn", "customDialogBtn");
        button.onclick = action;

        SessionTimer.buttonsHolder.appendChild(button);
        SessionTimer.buttons.push(button);
    }

    //******************************************************************************************************************
    //  ACTIONS
    //******************************************************************************************************************

    protected static actionContinue(): void {
        PlayList.play("SND_Click");

        SessionTimer.disableAllButtons();

        let interval: number;
        if (SessionTimer.intervals != null && SessionTimer.intervalIndex > 0) {
            interval = SessionTimer.intervals[SessionTimer.intervalIndex];
        }
        GameManager.gameClient.resetRealityCheck(interval).then((response: Communication.Game.RealityCheckResponse) => {
            this.onActionContinueReceived();
        });
    }

    protected static onActionContinueReceived(): void {
        SessionTimer.handle();
    }

    protected static actionExit(): void {
        PlayList.play("SND_Click");

        SessionTimer.disableAllButtons();

        GameManager.gameClient.closeRealityCheck().then((response: Communication.Game.RealityCheckResponse) => {
            this.onActionExitReceived();
        });
    }

    protected static onActionExitReceived(): void {
        Platforms.Platforms.exitHandler = "responsibleDialog";
        GameApp.exit();
    }

    //******************************************************************************************************************
    //  HANDLE
    //******************************************************************************************************************

    protected static handle(): void {
        if (SessionTimer.response.messages.length === SessionTimer.step) {
            SessionTimer.dialog.classList.add("_disabled");
            SessionTimer.callback(SessionTimer.response);
            Platforms.Platforms.dialogOpened("sessionTimer", false);
        } else {
            if (SessionTimer.response.messages[SessionTimer.step].type == "plugin") {
                Platforms.Platforms.sendPluginMessage(SessionTimer.response.messages[SessionTimer.step].text);
                SessionTimer.step++;
                SessionTimer.handle();
            } else {
                SessionTimer.dialog.classList.remove("_disabled");
                SessionTimer.updateDialogData(SessionTimer.response.messages[SessionTimer.step]);
                SessionTimer.step++;
                Platforms.Platforms.dialogOpened("sessionTimer", true);
            }
        }
    }

    //******************************************************************************************************************
    //  CUSTOM
    //******************************************************************************************************************

    protected static createIntervals(intervals: Array<number>): void {
        if (SessionTimer.buttonsHolder != null) {
            SessionTimer.intervals = intervals;
            SessionTimer.intervalIndex = 0;

            SessionTimer.intervalHolder = document.createElement("div");
            SessionTimer.intervalHolder.setAttribute("class", "sessionIntervals");

            let buttonMinus = document.createElement("div");
            buttonMinus.setAttribute("class", "minusBtn");
            buttonMinus.textContent = "-";

            let buttonPlus = document.createElement("div");
            buttonPlus.setAttribute("class", "plusBtn");
            buttonPlus.textContent = "+";

            buttonMinus.addEventListener(
                "click",
                SessionTimer.changeInterval.bind(this, true, buttonMinus, buttonPlus),
            );
            buttonPlus.addEventListener(
                "click",
                SessionTimer.changeInterval.bind(this, false, buttonMinus, buttonPlus),
            );

            SessionTimer.intervalDisplay = document.createElement("div");
            SessionTimer.intervalDisplay.setAttribute("class", "value");
            SessionTimer.intervalDisplay.innerText = intervals[0].toString();

            if (SessionTimer.intervalIndex == SessionTimer.intervals.length - 1) {
                buttonMinus.classList.add("_disabled");
            }

            if (SessionTimer.intervalIndex == 0) {
                buttonPlus.classList.add("_disabled");
            }

            SessionTimer.intervalHolder.appendChild(buttonMinus);
            SessionTimer.intervalHolder.appendChild(SessionTimer.intervalDisplay);
            SessionTimer.intervalHolder.appendChild(buttonPlus);
            SessionTimer.buttonsHolder.parentElement.insertBefore(
                SessionTimer.intervalHolder,
                SessionTimer.buttonsHolder,
            );
        }
    }

    protected static changeInterval(
        increase: boolean = false,
        buttonMinus: HTMLElement,
        buttonPlus: HTMLElement,
    ): void {
        buttonMinus.classList.remove("_disabled");
        buttonPlus.classList.remove("_disabled");

        if (increase) {
            if (SessionTimer.intervalIndex < SessionTimer.intervals.length - 1) {
                SessionTimer.intervalIndex++;
            }
        } else {
            if (SessionTimer.intervalIndex > 0) {
                SessionTimer.intervalIndex--;
            }
        }

        if (SessionTimer.intervalIndex == SessionTimer.intervals.length - 1) {
            buttonMinus.classList.add("_disabled");
        }

        if (SessionTimer.intervalIndex == 0) {
            buttonPlus.classList.add("_disabled");
        }

        SessionTimer.intervalDisplay.innerText = SessionTimer.intervals[SessionTimer.intervalIndex].toString();
    }

    public static callbackFnc(response: any): void {
        SessionTimer.dialog.classList.remove("sessionTimer");
        BaseModel.spinContinue();
    }

    public static prepareData(response: IErrorResponse): any {
        return {
            messages: [
                {
                    text: response.message,
                    actions: [
                        {
                            type: "continue",
                            text: Languages.getRid("CONTINUE"),
                        },
                        {
                            type: "exit",
                            text: Languages.getRid("CLOSE"),
                        },
                    ],
                    intervals: response.intervals,
                },
            ],
        };
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Platforms/Playtech/SessionTimer.ts
 **/